
export function RLParseNumberModel() {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: ng.INgModelController) => {
            var precision = parseInt(attributes["rlParseNumberModel"]);

            controller.$parsers.push((value: string) => {
                var numberOutput = parseFloat(value.replace(/[^0-9\.]/, ""));
                if (numberOutput == NaN) {
                    return undefined;
                }
                //if (precision != NaN) {
                //	if (numberOutput % 1 != 0) {
                //		return numberOutput.toFixed(precision);
                //	} else {
                //		return numberOutput;
                //	}
                //}
                return numberOutput;
            });

            //controller.$formatters.push((value: any) => {
            //    if (_.isNumber(value)) {
            //        return (<number>value).toFixed(2);
            //    }
            //    return value;
            //});

            //controller.$validators["moneyAmount2"] = (value: any) => {
            //    if (_.isNumber(value)) {
            //        var strAmount = (<number>value).toString();
            //        if (strAmount.indexOf(".") > -1) {
            //            var precision = strAmount.split(".")[1].length;
            //            return (precision == 0 || precision == 2);
            //        }
            //    }
            //    return true;
            //};
        }
    };
    return directive;
}

